import React, { useState } from 'react';
import '../App.css';

// Função para tracking de conversão
const trackConversion = (eventName) => {
    const eventId = 'event_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);

    // Facebook Pixel (Browser)
    if (window.fbq) {
        window.fbq('track', 'Lead', {}, { eventID: eventId });
    }

    // Google Analytics 4
    if (window.gtag) {
        window.gtag('event', eventName, {
            'event_category': 'engagement',
            'event_label': 'CTA Click'
        });
    }

    // Server-side Tracking (Meta CAPI via Cloudflare Worker)
    fetch('/api/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            eventName: 'Lead',
            eventSourceUrl: window.location.href,
            eventId: eventId,
            variant: 'B',
            origin: eventName
        })
    }).catch(err => console.error('CAPI Error:', err));

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'lead_conversion',
        'eventCategory': 'Lead',
        'eventAction': 'WhatsApp Click',
        'eventLabel': eventName,
        'eventId': eventId
    });
};

const handleWhatsAppClick = (origin) => {
    trackConversion(`whatsapp_click_${origin}_variant_b`);
    const messages = {
        'hero': 'Olá! Vi que a avaliação para Paciente Modelo no Grajaú é gratuita e quero agendar a minha!',
        'beneficios': 'Olá! Gostaria de agendar minha avaliação gratuita para o programa de paciente modelo.',
        'preco_modelo': 'Olá! Quero aproveitar a avaliação gratuita para o plano BOCA TODA como Paciente Modelo.',
        'preco_meia_arcada': 'Olá! Tenho interesse na avaliação gratuita para o plano MEIA ARCADA.',
        'cta_final': 'Olá! Quero agendar minha avaliação gratuita e garantir minha vaga exclusiva!',
        'sticky_mobile': 'Olá! Quero agendar minha avaliação gratuita para ser paciente modelo.',
        'banner': 'Olá! Quero agendar minha avaliação gratuita para ser paciente modelo.',
        'social_cta': 'Olá! Vi os resultados de antes e depois e eu quero esse resultado também!'
    };
    const message = (messages[origin] || messages['hero']) + ' ²';
    window.open(`https://wa.me/5511939300849?text=${encodeURIComponent(message)}`, '_blank');
};

function MysteryLP() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const [itemsToShow, setItemsToShow] = useState(window.innerWidth <= 768 ? 1 : (window.innerWidth <= 992 ? 2 : 3));
    const [activeAccordion, setActiveAccordion] = useState(null);

    const toggleAccordion = (index) => {
        setActiveAccordion(activeAccordion === index ? null : index);
    };

    const minSwipeDistance = 50;

    const [showSticky, setShowSticky] = useState(false);
    const [notificationText, setNotificationText] = useState("");

    React.useEffect(() => {
        let timers = [];

        const stickyTimer = setTimeout(() => {
            setShowSticky(true);

            // Primeira mensagem
            const firstMsgTimer = setTimeout(() => {
                setNotificationText("Vamos agendar uma avaliação gratuita?");

                const hideFirstMsgTimer = setTimeout(() => {
                    setNotificationText("");

                    // Segunda mensagem após 8 segundos
                    const secondMsgTimer = setTimeout(() => {
                        setNotificationText("Temos apenas 5 vagas tá");

                        const hideSecondMsgTimer = setTimeout(() => {
                            setNotificationText("");
                        }, 4000);
                        timers.push(hideSecondMsgTimer);
                    }, 8000);
                    timers.push(secondMsgTimer);
                }, 4000);
                timers.push(hideFirstMsgTimer);
            }, 10000);
            timers.push(firstMsgTimer);
        }, 3000);
        timers.push(stickyTimer);

        const handleResize = () => {
            setItemsToShow(window.innerWidth <= 768 ? 1 : (window.innerWidth <= 992 ? 2 : 3));
        };

        window.addEventListener('resize', handleResize);
        return () => {
            timers.forEach(clearTimeout);
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const cases = [
        {
            id: '01',
            before: 'Foco em Cor e Brilho',
            after: 'Eliminei o tom amarelado que me incomodava há anos. Impressionante como o brilho voltou em apenas uma tarde, com acabamento super natural e sem qualquer desgaste nos dentes.',
            icon: 'bi-heart-fill text-danger',
            imgBefore: '/paciente1-antes.webp',
            imgAfter: '/paciente1-depois.webp'
        },
        {
            id: '02',
            before: 'Foco em Alinhamento e Espaços',
            after: 'Os espaços entre os dentes sumiram e o sorriso ficou harmônico. Foi o melhor custo-benefício que encontrei: resultado de aparelho, mas resolvido em uma única sessão rápida.',
            icon: 'bi-star-fill text-warning',
            imgBefore: '/paciente2-antes.webp',
            imgAfter: '/paciente2-depois.webp'
        },
        {
            id: '03',
            before: 'Foco em Harmonia Facial',
            after: 'Eu buscava um sorriso simétrico e iluminado. Consegui a estética de capa de revista com investimento acessível e a segurança de um material de altíssima qualidade profissional.',
            icon: 'bi-shield-check text-success',
            imgBefore: '/paciente3-antes.webp',
            imgAfter: '/paciente3-depois.webp'
        },
        {
            id: '04',
            before: 'Foco em Rejuvenescimento',
            after: 'Meus dentes estavam desgastados e com aparência envelhecida. Em poucas horas, recuperei o volume e formato ideal. O rosto todo parece muito mais firme, leve e renovado agora.',
            icon: 'bi-lightning-fill text-warning',
            imgBefore: '/paciente4-antes.webp',
            imgAfter: '/paciente4-depois.webp'
        },
        {
            id: '05',
            before: 'Foco em Correção de Imperfeições',
            after: 'Corrigi irregularidades de forma e tamanho que me impediam de sorrir. Procedimento rápido, indolor e com um polimento que faz toda a diferença no brilho do meu dia a dia.',
            icon: 'bi-gem text-primary',
            imgBefore: '/paciente5-antes.webp',
            imgAfter: '/paciente5-depois.webp'
        },
        /*
        {
            id: '06',
            before: 'Foco em Praticidade e Preço',
            after: 'Sempre achei que dentes perfeitos eram caros demais. Com as facetas em resina, conquistei um sorriso de artista com preço justo e a praticidade de sair com tudo pronto hoje.',
            icon: 'bi-clock-fill text-info',
            imgBefore: '/paciente6-antes.webp',
            imgAfter: '/paciente6-depois.webp'
        }
        */
    ];

    const nextSlide = () => {
        const maxIndex = cases.length - itemsToShow;
        setCurrentIndex(prev => (prev >= maxIndex ? 0 : prev + 1));
    };

    const prevSlide = () => {
        const maxIndex = cases.length - itemsToShow;
        setCurrentIndex(prev => (prev <= 0 ? maxIndex : prev - 1));
    };

    const handleTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (!touchStart || !touchEnd) return;
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;
        if (isLeftSwipe) {
            nextSlide();
        } else if (isRightSwipe) {
            prevSlide();
        }
    };

    return (
        <div className="App mystery-lp" style={{ backgroundColor: '#fff', color: '#2d3436' }}>

            {/* Banner Superior - Amarelo vibrante para atenção imediata */}
            <div className="floating-banner" style={{ background: '#FFD700', color: '#000', fontWeight: '800', border: 'none' }}>
                <i className="bi bi-clock-fill"></i>
                &nbsp;OFERTA LIMITADA: Apenas 5 vagas para Paciente Modelo no Grajaú e Região
            </div>

            {/* Hero Section - Soft Black (Grafite Profundo) e Yellow */}
            <section className="hero-section" style={{
                background: 'linear-gradient(135deg, #1e272e 0%, #2d3436 100%)',
                color: '#fff',
                padding: '120px 0 80px 0',
                clipPath: 'polygon(0 0, 100% 0, 100% 95%, 0 100%)'
            }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-7">
                            <div className="hero-badge" style={{ background: 'rgba(255, 215, 0, 0.15)', color: '#FFD700', border: '1px solid #FFD700' }}>
                                <i className="bi bi-patch-check-fill"></i> OPORTUNIDADE EXCLUSIVA
                            </div>
                            <h1 className="hero-title" style={{ color: '#FFD700', fontWeight: '900', fontSize: '2.5rem' }}>
                                Descubra como ter o Sorriso dos Artistas sem gastar uma fortuna.
                            </h1>
                            <p className="hero-subtitle" style={{ color: '#d1d8e0' }}>
                                Transformação estética premium com economia real. Seja um dos selecionados para nosso <span style={{ color: '#FFD700', fontWeight: '700' }}>Programa de Paciente Modelo</span>.
                            </p>
                            <button
                                className="cta-button"
                                onClick={() => handleWhatsAppClick('hero')}
                                style={{ background: '#FFD700', color: '#000', fontWeight: '800', border: 'none', transform: 'scale(1.1)' }}
                            >
                                <i className="bi bi-whatsapp"></i> QUERO MINHA AVALIAÇÃO GRATUITA
                            </button>
                            <div className="mt-4" style={{ opacity: 0.8 }}>
                                <small><i className="bi bi-shield-lock"></i> Vagas limitadas no Grajaú | <i className="bi bi-star-fill text-warning"></i> +500 Sorrisos Restaurados</small>
                            </div>
                        </div>
                        <div className="col-lg-5 mt-5 mt-lg-0">
                            <div className="hero-image-container" style={{ position: 'relative' }}>
                                <div style={{
                                    position: 'absolute',
                                    top: '-15px',
                                    right: '15px',
                                    background: '#FFD700',
                                    color: '#000',
                                    padding: '10px 20px',
                                    borderRadius: '10px',
                                    fontWeight: '900',
                                    zIndex: '2',
                                    boxShadow: '0 5px 15px rgba(0,0,0,0.3)'
                                }}>
                                    60% OFF
                                </div>
                                <picture>
                                    <source srcSet="/principal-mobile.webp" media="(max-width: 768px)" />
                                    <img
                                        src="/principal.webp"
                                        alt="Sorriso Luppe"
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            maxHeight: '450px',
                                            borderRadius: '20px',
                                            border: '5px solid #FFD700',
                                            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
                                            objectFit: 'cover'
                                        }}
                                    />
                                </picture>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Seção de Prova Social - Sincronizada com Página A */}
            <section className="prova-social-section" style={{ padding: '80px 0', background: '#1e272e', borderTop: '1px solid #333' }}>
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="section-title" style={{ color: '#FFD700', fontWeight: '900' }}>Transformações Reais na Estética Bucal</h2>
                        <p className="section-subtitle" style={{ color: '#fff', fontWeight: '500', opacity: 0.9 }}>Veja como nossas Facetas de Resina transformam sorrisos no Grajaú</p>
                        <div style={{ width: '80px', height: '5px', background: '#FFD700', margin: '20px auto' }}></div>
                    </div>

                    <div className="carousel-container">
                        <button className="carousel-control prev" onClick={prevSlide} aria-label="Depoimento anterior">
                            <i className="bi bi-chevron-left"></i>
                        </button>

                        <div
                            className="carousel-track-wrapper"
                            onTouchStart={handleTouchStart}
                            onTouchMove={handleTouchMove}
                            onTouchEnd={handleTouchEnd}
                        >
                            <div
                                className="carousel-track"
                                style={{
                                    transform: `translateX(-${currentIndex * (100 / itemsToShow)}%)`
                                }}
                            >
                                {cases.map((patient) => (
                                    <div className="carousel-item-custom" key={patient.id}>
                                        <div className="before-after-card" style={{ background: '#fff' }}>
                                            <div className="before-after-image">
                                                <span className="before-after-label" style={{ background: '#FFD700', color: '#000' }}>CASO {patient.id}</span>
                                                <div className="d-flex w-100 h-100">
                                                    <div className="w-50 h-100 border-end d-flex align-items-center justify-content-center bg-light overflow-hidden">
                                                        {patient.imgBefore ? (
                                                            <img
                                                                src={patient.imgBefore}
                                                                alt={`Dentes do paciente ${patient.id} antes do tratamento`}
                                                                width="400"
                                                                height="300"
                                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                            />
                                                        ) : (
                                                            <span className="text-muted small">ANTES</span>
                                                        )}
                                                    </div>
                                                    <div className="w-50 h-100 d-flex align-items-center justify-content-center overflow-hidden">
                                                        {patient.imgAfter ? (
                                                            <img
                                                                src={patient.imgAfter}
                                                                alt={`Dentes do paciente ${patient.id} depois do tratamento com facetas em resina`}
                                                                width="400"
                                                                height="300"
                                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                            />
                                                        ) : (
                                                            <span className="text-dark small">DEPOIS</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="before-after-content" style={{ padding: '20px', textAlign: 'left' }}>
                                                <p className="mb-0" style={{ fontSize: '0.9rem', color: '#2d3436', lineHeight: '1.5' }}>
                                                    {patient.after}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <button className="carousel-control next" onClick={nextSlide} aria-label="Próximo depoimento">
                            <i className="bi bi-chevron-right"></i>
                        </button>

                        <div className="carousel-indicators">
                            {Array.from({ length: cases.length - itemsToShow + 1 }).map((_, idx) => (
                                <button
                                    key={idx}
                                    className={`indicator-dot ${currentIndex === idx ? 'active' : ''}`}
                                    onClick={() => setCurrentIndex(idx)}
                                    aria-label={`Ir para slide ${idx + 1}`}
                                />
                            ))}
                        </div>
                    </div>

                    <div className="text-center mt-5">
                        <button
                            className="cta-button"
                            onClick={() => handleWhatsAppClick('social_cta')}
                            style={{ background: '#FFD700', color: '#000', fontWeight: '800', border: 'none' }}
                        >
                            <i className="bi bi-whatsapp"></i> EU QUERO ESSE RESULTADO TAMBÉM
                        </button>
                    </div>

                    {/* Explicação do Preço Baixo / Parceria */}
                    <div className="mt-5 row justify-content-center">
                        <div className="col-lg-10">
                            <div className="p-4 rounded shadow-sm" style={{ background: '#fff', borderLeft: '5px solid #FFD700' }}>
                                <h2 style={{ color: '#1e272e', fontWeight: '800' }}>Por Que o Preço é Tão Vantajoso?</h2>
                                <p style={{ fontSize: '1.1rem', color: '#444' }}>
                                    Este valor exclusivo é oferecido para pacientes que autorizam o uso das fotos de "Antes e Depois" para divulgação da clínica. Isso nos permite demonstrar a excelência do nosso trabalho e ajudar mais pessoas a conhecerem a qualidade dos nossos serviços.
                                </p>
                                <p className="mb-0" style={{ fontSize: '1.1rem', color: '#444', borderTop: '1px solid #eee', paddingTop: '15px' }}>
                                    <strong>Não é preço baixo por qualidade inferior</strong> — é uma parceria onde você recebe tratamento premium e nós ganhamos material para mostrar nosso trabalho!
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            {/* Seção de Benefícios - Contrastando com Soft Dark Background */}
            <section className="beneficios-section" style={{ background: '#2d3436', color: '#fff', padding: '80px 0' }}>
                <div className="container">
                    <h2 className="visually-hidden">Nossos Diferenciais</h2>
                    <div className="row g-4">
                        <div className="col-md-3 text-center">
                            <i className="bi bi-lightning-charge" style={{ fontSize: '2.5rem', color: '#FFD700' }}></i>
                            <h3 className="mt-3">Sessão Única</h3>
                            <p style={{ color: '#a4b0be' }}>Seu novo sorriso pronto em poucas horas.</p>
                        </div>
                        <div className="col-md-3 text-center">
                            <i className="bi bi-gem" style={{ fontSize: '2.5rem', color: '#FFD700' }}></i>
                            <h3 className="mt-3">Alta Estética</h3>
                            <p style={{ color: '#a4b0be' }}>Naturalidade e brilho permanente.</p>
                        </div>
                        <div className="col-md-3 text-center">
                            <i className="bi bi-heart-pulse" style={{ fontSize: '2.5rem', color: '#FFD700' }}></i>
                            <h3 className="mt-3">Conforto Total</h3>
                            <p style={{ color: '#a4b0be' }}>Procedimento indolor e seguro.</p>
                        </div>
                        <div className="col-md-3 text-center">
                            <i className="bi bi-chat-dots-fill" style={{ fontSize: '2.5rem', color: '#FFD700' }}></i>
                            <h3 className="mt-3">Suporte Real</h3>
                            <p style={{ color: '#a4b0be' }}>Tire todas as suas dúvidas no WhatsApp.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Preços - Diferenciando no layout de cards */}
            <section className="preco-section" style={{ padding: '100px 0', background: '#fff' }}>
                <div className="container text-center">
                    <h2 className="section-title mb-5">Planos Paciente Modelo</h2>
                    <div className="row g-4 justify-content-center">
                        <div className="col-md-6 col-lg-5">
                            <div className="preco-card" style={{ border: '3px solid #FFD700', borderRadius: '30px', transform: 'scale(1.05)' }}>
                                <div style={{ background: '#FFD700', color: '#000', padding: '10px', fontWeight: 'bold', borderRadius: '20px 20px 0 0' }}>MAIS PROCURADO</div>
                                <h3 className="mt-4">Boca Toda</h3>
                                <p className="text-muted">Superior + Inferior</p>
                                <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                                    <img
                                        src="/bocatoda.webp"
                                        alt="Ilustração Boca Toda"
                                        width="130"
                                        height="75"
                                        style={{ borderRadius: '12px', border: '2px solid #FFD700', objectFit: 'cover' }}
                                    />
                                </div>
                                <div className="my-4">
                                    <span style={{ textDecoration: 'line-through', color: '#888' }}>De R$ 5.000,00</span>
                                    <div style={{ fontSize: '1rem', color: '#666', marginTop: '10px' }}>Por apenas</div>
                                    <div style={{ fontSize: '3rem', fontWeight: '900', color: '#2d3436' }}>R$ 2.000,00</div>
                                    <span className="badge bg-dark">Economia de R$ 3.000,00</span>
                                </div>
                                <ul style={{ listStyle: 'none', padding: 0, textAlign: 'left', display: 'inline-block' }}>
                                    <li className="mb-2"><i className="bi bi-check2-circle text-success"></i> 12 a 14 Facetas em Resina</li>
                                    <li className="mb-2"><i className="bi bi-check2-circle text-success"></i> Acabamento de Alto Brilho</li>
                                    <li className="mb-2"><i className="bi bi-check2-circle text-success"></i> Planejamento Personalizado</li>
                                </ul>
                                <div className="mt-2 text-muted small">
                                    <i className="bi bi-credit-card"></i> PIX • Cartão de Crédito • Débito
                                </div>
                                <button
                                    className="cta-button w-100 mt-4"
                                    onClick={() => handleWhatsAppClick('preco_modelo')}
                                    style={{ background: '#FFD700', color: '#000', fontWeight: 'bold' }}
                                >
                                    <i className="bi bi-whatsapp"></i> QUERO MINHA AVALIAÇÃO GRATUITA
                                </button>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-5">
                            <div className="preco-card" style={{ border: '1px solid #eee', borderRadius: '30px' }}>
                                <h3 className="mt-5">Meia Arcada</h3>
                                <p className="text-muted">Superior ou Inferior</p>
                                <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                                    <img
                                        src="/meiaarcada.webp"
                                        alt="Ilustração Meia Arcada"
                                        width="130"
                                        height="75"
                                        style={{ borderRadius: '12px', border: '1px solid #eee', objectFit: 'cover' }}
                                    />
                                </div>
                                <div className="my-4">
                                    <span style={{ textDecoration: 'line-through', color: '#888' }}>De R$ 2.500,00</span>
                                    <div style={{ fontSize: '1rem', color: '#666', marginTop: '10px' }}>Por apenas</div>
                                    <div style={{ fontSize: '3rem', fontWeight: '900', color: '#2d3436' }}>R$ 1.200,00</div>
                                </div>
                                <ul style={{ listStyle: 'none', padding: 0, textAlign: 'left', display: 'inline-block' }}>
                                    <li className="mb-2"><i className="bi bi-check2-circle text-success"></i> 6 a 8 Facetas em Resina</li>
                                    <li className="mb-2"><i className="bi bi-check2-circle text-success"></i> Sorriso Harmonioso</li>
                                    <li className="mb-2"><i className="bi bi-check2-circle text-success"></i> Rápido e Eficiente</li>
                                </ul>
                                <div className="mt-2 text-muted small">
                                    <i className="bi bi-credit-card"></i> PIX • Cartão de Crédito • Débito
                                </div>
                                <button
                                    className="cta-button w-100 mt-4"
                                    onClick={() => handleWhatsAppClick('preco_meia_arcada')}
                                    style={{ background: '#2d3436', color: '#fff' }}
                                >
                                    <i className="bi bi-whatsapp"></i> AGENDAR AVALIAÇÃO GRATUITA
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Localização */}
                    <div className="row justify-content-center mt-5">
                        <div className="col-lg-8">
                            <div className="location-block" style={{ background: '#fff', border: '2px dashed #FFD700' }}>
                                <h3 className="location-title" style={{ color: '#2d3436' }}><i className="bi bi-geo-alt-fill text-warning"></i> Pertinho de você no Grajaú</h3>
                                <p style={{ fontSize: '1.1rem', color: '#555' }}>
                                    Estamos localizados na <strong>Avenida Prefeito Paulo Lauro, 889</strong>.
                                </p>
                                <p style={{ fontSize: '1rem', color: '#444' }}>
                                    <i className="bi bi-compass"></i> Próximo à Estação Grajaú e à Av. Belmira Marin.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Garantia de Naturalidade */}
            <section className="guarantee-section" style={{ background: '#2d3436', color: '#fff' }}>
                <div className="container">
                    <div className="guarantee-content">
                        <h2 className="section-title mb-4" style={{ color: '#FFD700' }}>Medo de ficar artificial?</h2>
                        <p className="section-subtitle mb-5" style={{ color: '#d1d8e0' }}>
                            Nossa tecnologia de <strong>Resina de Alta Performance</strong> imita a textura,
                            translucidez e brilho do dente natural. Nada de "sorriso de pastilha".
                        </p>
                        <div className="row align-items-center">
                            <div className="col-md-6 mb-4 mb-md-0">
                                <div style={{ background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '15px', height: '100%' }}>
                                    <i className="bi bi-gem text-warning" style={{ fontSize: '3rem', marginBottom: '15px' }}></i>
                                    <h3 style={{ color: '#fff' }}>Textura Realista</h3>
                                    <p style={{ color: '#a4b0be' }}>Micro-detalhes que simulam o esmalte natural.</p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div style={{ background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '15px', height: '100%' }}>
                                    <i className="bi bi-layers-half text-warning" style={{ fontSize: '3rem', marginBottom: '15px' }}></i>
                                    <h3 style={{ color: '#fff' }}>Camadas de Cor</h3>
                                    <p style={{ color: '#a4b0be' }}>Profundidade e degradê que dão vida ao sorriso.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ Section */}
            <section className="faq-section" style={{ background: '#f5f6fa' }}>
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="section-title" style={{ color: '#2d3436' }}>Perguntas Frequentes</h2>
                        <p className="section-subtitle">Tire suas dúvidas sobre o tratamento</p>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            {/* Pergunta 1 */}
                            <div className="accordion-item">
                                <button
                                    className="accordion-header"
                                    onClick={() => toggleAccordion(0)}
                                    aria-expanded={activeAccordion === 0}
                                    style={{ width: '100%', textAlign: 'left', border: 'none', background: 'none', color: '#2d3436' }}
                                >
                                    Precisa desgastar meus dentes?
                                    <i className={`bi bi-chevron-down accordion-icon ${activeAccordion === 0 ? 'rotate' : ''}`}></i>
                                </button>
                                <div className={`accordion-content ${activeAccordion === 0 ? 'active' : ''}`}>
                                    Na grande maioria dos casos, utilizamos uma <strong>técnica aditiva</strong>, ou seja,
                                    apenas adicionamos a resina sobre o seu dente sem necessidade de desgaste agressivo.
                                    É um procedimento seguro e conservador.
                                </div>
                            </div>

                            {/* Pergunta 2 */}
                            <div className="accordion-item">
                                <button
                                    className="accordion-header"
                                    onClick={() => toggleAccordion(1)}
                                    aria-expanded={activeAccordion === 1}
                                    style={{ width: '100%', textAlign: 'left', border: 'none', background: 'none', color: '#2d3436' }}
                                >
                                    Quanto tempo dura?
                                    <i className={`bi bi-chevron-down accordion-icon ${activeAccordion === 1 ? 'rotate' : ''}`}></i>
                                </button>
                                <div className={`accordion-content ${activeAccordion === 1 ? 'active' : ''}`}>
                                    Com os cuidados adequados e manutenção anual (polimento), as facetas em resina
                                    podem manter o brilho e beleza por muitos anos. A durabilidade média é excelente,
                                    sendo um dos melhores investimentos estéticos.
                                </div>
                            </div>

                            {/* Pergunta 3 */}
                            <div className="accordion-item">
                                <button
                                    className="accordion-header"
                                    onClick={() => toggleAccordion(2)}
                                    aria-expanded={activeAccordion === 2}
                                    style={{ width: '100%', textAlign: 'left', border: 'none', background: 'none', color: '#2d3436' }}
                                >
                                    Consigo parcelar o pagamento?
                                    <i className={`bi bi-chevron-down accordion-icon ${activeAccordion === 2 ? 'rotate' : ''}`}></i>
                                </button>
                                <div className={`accordion-content ${activeAccordion === 2 ? 'active' : ''}`}>
                                    Sim! Sabemos que à vista pode ser pesado, por isso parcelamos no <strong>Cartão de Crédito</strong>.
                                    Nosso objetivo é viabilizar o seu sonho de forma que caiba no seu bolso.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Final - Fora do Footer para melhor impacto visual */}
            <section className="cta-final-section" style={{ background: '#FFD700', padding: '100px 0' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 text-center" style={{ color: '#000' }}>
                            <h2 style={{ fontSize: '3rem', fontWeight: '900' }}>Está Pronto para Transformar Seu Sorriso?</h2>
                            <p style={{ fontSize: '1.2rem', marginBottom: '40px' }}>Últimas vagas para o programa no Grajaú. Garanta a sua agora mesmo!</p>
                            <button
                                className="cta-button-large"
                                onClick={() => handleWhatsAppClick('cta_final')}
                                style={{ background: '#000', color: '#FFD700', border: 'none', padding: '25px 60px', fontSize: '1.5rem', fontWeight: '900' }}
                            >
                                <i className="bi bi-whatsapp"></i> AGENDAR AVALIAÇÃO AGORA
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* Rodapé - Cópia fiel da Página A com ajuste de cores */}
            <footer className="footer" style={{ borderTop: '5px solid #FFD700' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="footer-logo">
                                <i className="bi bi-heart-pulse-fill"></i> LUPPE SAÚDE
                            </div>
                            <p style={{ fontSize: '1.1rem', marginBottom: '10px' }}>Odontologia</p>

                            <div className="footer-address">
                                <p>
                                    <i className="bi bi-geo-alt-fill"></i>
                                    <strong>Avenida Prefeito Paulo Lauro, 889</strong><br />
                                    <span style={{ marginLeft: '30px' }}>Grajaú, São Paulo - SP</span>
                                </p>
                                <p>
                                    <i className="bi bi-telephone-fill"></i>
                                    <strong>(11) 93930-0849</strong>
                                </p>
                                <p>
                                    <i className="bi bi-instagram"></i>
                                    <a
                                        href="https://www.instagram.com/clinicaluppe/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: '#FFD700', textDecoration: 'none', fontWeight: 'bold' }}
                                    >
                                        @clinicaluppe
                                    </a>
                                </p>
                                <p>
                                    <i className="bi bi-whatsapp"></i>
                                    <a
                                        href="https://wa.me/5511939300849"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: '#FFD700', textDecoration: 'none', fontWeight: 'bold' }}
                                    >
                                        Fale conosco pelo WhatsApp
                                    </a>
                                </p>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <h3 style={{ color: '#FFD700', marginBottom: '20px', fontSize: '1.3rem' }}>
                                Nossa Missão
                            </h3>
                            <div className="footer-mission" style={{ background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '10px' }}>
                                <p style={{ marginBottom: 0, fontSize: '1.05rem', fontStyle: 'italic' }}>
                                    "Tornar o atendimento odontológico <strong>acessível</strong>,
                                    <strong> técnico</strong> e <strong>humano</strong>."
                                </p>
                            </div>

                            <div className="mt-4">
                                <h4 style={{ color: '#FFD700', fontSize: '1.1rem', marginBottom: '15px' }}>
                                    Serviços em Destaque
                                </h4>
                                <ul style={{ listStyle: 'none', padding: 0, lineHeight: '2' }}>
                                    <li><i className="bi bi-check-circle-fill text-warning me-2"></i>Facetas em Resina</li>
                                    <li><i className="bi bi-check-circle-fill text-warning me-2"></i>Estética Bucal</li>
                                    <li><i className="bi bi-check-circle-fill text-warning me-2"></i>Odontologia Geral</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="footer-bottom" style={{ borderTop: '1px solid #333', marginTop: '40px', paddingTop: '20px', textAlign: 'center' }}>
                        <p>&copy; 2026 Luppe Saúde - Odontologia. Todos os direitos reservados.</p>
                        <p>
                            Desenvolvido com <i className="bi bi-heart-fill" style={{ color: '#FF4757' }}></i> para transformar sorrisos na Zona Sul de SP
                        </p>
                    </div>
                </div>
            </footer>
            {showSticky && (
                <div
                    onClick={() => handleWhatsAppClick('sticky_mobile')}
                    className="sticky-cta-mobile"
                    style={{ cursor: 'pointer' }}
                    title="Agendar Avaliação"
                >
                    {notificationText && (
                        <div className="whatsapp-notification">
                            {notificationText}
                        </div>
                    )}
                    <i className="bi bi-whatsapp"></i>
                </div>
            )}
        </div>
    );
}

export default MysteryLP;
